import nationalAvgData from 'src/constants/national-avg.json'
import nationalAvgDataCbg from 'src/constants/demographics-cbg-avg.json'
import nationalAvgDataZipCode from 'src/constants/demographics-zipcode-avg.json'
import { getCurrentYear } from 'src/utils/date-utils'

// value is in sq miles
export const getNationalAvgInRadius = (value: number, radius: number) => {
  return Math.round(value * radius * radius * Math.PI)
}

// value is in sq miles
export const getNationalAvgInArea = (value: number, area: number) => {
  return Math.round(value * area)
}

export type NationalAvgDataType = 'mile' | 'cbg' | 'zipcode' | 'h3'
export const getNationalAverageData = (type: NationalAvgDataType = 'mile') => {
  switch (type) {
    case 'cbg':
      return { ...nationalAvgDataCbg }
    case 'zipcode':
      return { ...nationalAvgDataZipCode }
    case 'mile':
    default:
      return { ...nationalAvgData }
  }
}

export const FIVE_YEAR_FORECAST_TEXT = `${getCurrentYear() + 5} Forecast`
